const UserStatusEnum = {
    ACTIVE: 'ACTIVE',
    DISABLED: 'DISABLED',
  };

export default UserStatusEnum;